<script setup lang="ts">
import type { TenantLandingConfig } from '~/types/types'
import { socialLinks } from '~/composables/useLandingTemplate'

const props = defineProps<{ landing: TenantLandingConfig }>()

const socials = computed(() => socialLinks(props.landing))
</script>

<template>
  <section
    v-if="socials.length"
    class="px-6 py-10 text-center"
  >
    <div class="inline-flex gap-3">
      <a
        v-for="s in socials"
        :key="s.href"
        :href="s.href"
        target="_blank"
        rel="noopener"
        class="flex h-10 w-10 items-center justify-center rounded-full border border-[var(--border)] hover:bg-[var(--bg3)] transition-colors ui-text-subtle"
      >
        <UIcon
          :name="s.icon"
          class="size-4"
        />
      </a>
    </div>
  </section>
</template>
